<template>
  <article class="lk">
    <div class="lk_banner"></div>
    <div class="lk_content base_content">
      <div class="lk_title base_title">Личный кабинет</div>
      <div class="out_of_order-sign" v-if="!$store.getters.admin"></div>
      <div class="lk_content-admin" v-else>
        <div class="admin_buttons">
          <router-link to="/admin/launcher" class="base_link">
            <button type="button" class="btn btn_submit">Управление лаунчером</button>
          </router-link>
        </div>
      </div>
      <canvas class="lk_content-canvas" ref="canvas"></canvas>
      <div class="logout_button" @click="$store.dispatch('logout')">
        Выйти из аккаунта
      </div>
    </div>
  </article>
</template>
<script>
import Backend from '../services/backend.service';

const { SkinViewer } = require('skinview3d');

export default {
  name: 'Kabinet',
  data() {
    return {
      backend: new Backend(),
      skinImage: `/skins/${this.$store.getters.skin}`,
      skin: null,
    };
  },
  methods: {
    loadSkin() {
      this.skin = new SkinViewer({
        canvas: this.$refs.canvas,
        width: 128,
        height: 256,
        skin: this.skinImage,
      });
    },
  },
  mounted() {
    this.loadSkin();
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/variables.scss";
.lk{
  &_banner{
    aspect-ratio: 16/8;
    width: 100%;
    background: url('/static/lk-banner.jpg') no-repeat 50% 50% / cover;
    pointer-events: none;
  }
  &_content{
    .out_of_order-sign{
      width: 167px;
      height: 157px;
      position: relative;
      background: url('/static/out-of-order.png') no-repeat 50% 50% / contain;
      top: -30px;
      left: 160px;
    }
    &-admin{
      .admin{
        &_buttons{
          display: flex;
          .btn_submit{
            padding: 0 10px;
            box-shadow: none;
          }
        }
      }
      margin-bottom: 40px;
      .content{
        &_column{
          width: 24%;
          .column_title{
            color: white;
            font-family: $font;
            font-weight: normal;
            font-size: 24px;
            margin-bottom: 10px;
          }
          .new_social{
            .input_wide{
              margin-bottom: 10px;
            }
          }
        }
      }
    }
    &-canvas{
      image-rendering: pixelated;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Kabinet.vue